import { getConfig } from '../../config';
import { Activity, AdditionalCharges } from '../../types/Activity';
import { getMixPanelEncodingTitle } from '../utils/common';

const { batchWebURL } = getConfig();

export const ACTIVITIES_CSV_HEADERS = [
  { label: 'Product ID', key: 'id' },
  { label: 'Product Title', key: 'title' },
  { label: 'Vendor', key: 'vendorName' },
  { label: 'Description', key: 'description' },
  { label: 'Tags', key: 'tags' },
  { label: 'Hidden', key: 'hidden' },
  { label: 'City', key: 'city' },
  { label: 'Bookable', key: 'bookable' },
];

export const BOOKING_CSV_HEADERS = [
  { label: 'Variant ID', key: 'id' },
  { label: 'Booking Option Title', key: 'title' },
  { label: 'Product ID', key: 'activityId' },
  { label: 'Price', key: 'price' },
];

export const ACTIVITY_AVAILABLE_DAY_WEEKS = 'MON,TUE,WED,THU,FRI,SAT,SUN';

export const CANCELLATION_POLICY_OPTIONS = new Map([
  [
    'Generous',
    'Full refund on cancellations with 7+ days notice. No refund within 7 day window.',
  ],
  [
    'Moderate',
    '50% refund on cancellations with 7+ days notice. No refund within 7 day window.',
  ],
  [
    'Strict',
    'This experience partner offers no refunds once the reservation is confirmed',
  ],
]);

export const DEFAULT_ADDITIONAL_CHARGES: AdditionalCharges[] = [
  {
    name: 'Gratuity',
    percent: 0,
  },
  {
    name: 'Vendor Fees',
    percent: 0,
  },
];

export type ActivityActions = {
  label: string;
  image: {
    src: string;
    alt: string;
    width?: string;
  };
  type: string;
  href: string;
  show: boolean;
};

export const getActivityActions = (activity: Activity): ActivityActions[] => {
  const { id: activityId, title } = activity;
  if (!activityId || !title) {
    return [];
  }

  return [
    {
      label: 'View on web',
      image: { src: '/copy-square.png', alt: 'bach-web-link', width: '20px' },
      type: 'link',
      href: `${batchWebURL}/experiences/${activityId}#no_universal_links`,
      show: !!activityId,
    },
    {
      label: 'Copy activity deeplink',
      image: { src: '/copy-icon.svg', alt: 'page-deep-link', width: '20px' },
      type: 'button',
      href: `https://thebach.me/activity/${activityId}`,
      show: !!activityId,
    },
    {
      label: 'Copy rate activity deeplink',
      image: {
        src: '/copy-icon.svg',
        alt: 'rating-deep-link',
        width: '20px',
      },
      type: 'button',
      href: `https://thebach.me/rate-activity/${activityId}`,
      show: !!activityId,
    },
    {
      label: 'View in Mixpanel',
      image: { src: '/mixpanel-short.png', alt: 'mixpanel' },
      type: 'link',
      /* eslint-disable-next-line max-len */
      href: `https://mixpanel.com/report/1726253/view/18560/insights#~(columnWidths~(bar~())~displayOptions~(chartType~'line~plotStyle~'standard~analysis~'logarithmic~value~'absolute)~sorting~(bar~(sortBy~'column~colSortAttrs~(~(sortBy~'value~sortOrder~'desc)))~line~(sortBy~'value~sortOrder~'desc)~table~(sortBy~'column~colSortAttrs~(~(sortBy~'label~sortOrder~'asc))))~timeComparison~null~title~'~querySamplingEnabled~false~sections~(show~(~(dataset~'!mixpanel~value~(name~'product_page_viewed~resourceType~'events~renamed~'Activity*20Viewed)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'productName~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        title
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'productName*20equals*20${getMixPanelEncodingTitle(
        title
      )})~(dataset~'!mixpanel~value~(name~'productTagTapped~resourceType~'events~renamed~'Activity*20Tag*20Tapped)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'activityTitle~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        title
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'productName*20equals*20${getMixPanelEncodingTitle(
        title
      )})~(dataset~'!mixpanel~value~(name~'activityFavorited~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'activityId~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${activityId})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'activityId*20equals*20${activityId})~(dataset~'!mixpanel~value~(name~'poll_created~resourceType~'events~renamed~'Activity*20Poll*20Created)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'activityTitle~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        title
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'productName*20equals*20${getMixPanelEncodingTitle(
        title
      )})~(dataset~'!mixpanel~value~(name~'order_detail_page_viewed~resourceType~'events~renamed~'Activity*20Order*20Detail*20Screen*20Viewed)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'activityId~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${activityId})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'activityId*20equals*20${activityId})~(dataset~'!mixpanel~value~(name~'bookable_activity_purchase_made~resourceType~'events~renamed~'Activity*20Purchased)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'activityId~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${activityId})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'activityId*20equals*${activityId}))~time~(~(dateRangeType~'in*20the*20last~unit~'week~window~(value~8~unit~'week))))~legend~())`,
      show: !!activityId && !!title,
    },
  ];
};
